import { render } from "./BgFaceDivisionCountDisp.vue?vue&type=template&id=64d3188f&scoped=true"
import script from "./BgFaceDivisionCountDisp.vue?vue&type=script&lang=js"
export * from "./BgFaceDivisionCountDisp.vue?vue&type=script&lang=js"

import "./BgFaceDivisionCountDisp.vue?vue&type=style&index=0&id=64d3188f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-64d3188f"

export default script